/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'react-bootstrap-dialog';
import MemberStore from '../../stores/MemberStore';
import MembersActionCreators from '../../actions/MembersActionCreators';
import MemberLink from './MemberLink';
import MemberName from './MemberName';
import MemberImage from './MemberImage';
import MemberMenu from './MemberMenu';
import ImageSvg from '../image/ImageSvg';
import VerificationBadge from '../verification/VerificationBadge';

class MembersBlockItem extends React.Component {
  constructor(props) {
    super(props);
    this.showDialog = this.showDialog.bind(this);
    Dialog.setOptions({
      defaultOkLabel: translations['txt: Jā'],
      defaultCancelLabel: translations['txt: Atcelt'],
    });
  }

  onClickUnignore = () => {
    MembersActionCreators.unignore(this.props.memberId);
  };

  onClickUnblock = () => {
    MembersActionCreators.unblock(this.props.memberId);
  };

  showDialog(msg, callback) {
    this.dialog.show({
      body: msg,
      actions: [
        Dialog.CancelAction(), // eslint-disable-line babel/new-cap
        Dialog.OKAction(callback), // eslint-disable-line babel/new-cap
      ],
    });
  }

  render() {
    //
    const { memberId } = this.props;
    let { member } = this.props;
    if (!member) {
      member = MemberStore.get(memberId);
    }

    //
    const {
      topNr,
      customLink,
      showDistance,
      extended,
      type,
      subtype,
      customLinkClass,
      imageType,
      hideAnswerScore,
      hideVerificationBadge,
      hideAge,
      hideLocation,
      hideMenu,
      hideIcons,
      menuType,
    } = this.props;

    //
    const self = this;

    //
    let menuItems = ['score', 'ignore', 'block', 'wink', 'favorite'];

    if (menuType === 'admin') {
      menuItems = ['score', 'remove_profile_img', 'ban', 'delete'];
    }

    let menuFullOpacity = false;
    //
    let classNames = customLinkClass || 'member membersBlock-item ';
    //
    if (extended === true) {
      classNames += 'member--extended';
    }
    //
    if (type === 'admin') {
      classNames += ' member--adminView';
      //
      if (subtype === 'pending') {
        menuItems = ['score', 'approve'];
        menuFullOpacity = true;
      }
      //
      if (subtype === 'duplicates') {
        menuItems = [];
        if (!['deleted', 'admin'].includes(member.admin.status)) {
          menuItems.push('delete');
        }
      }
    }

    //
    const adminInfo = function adminInfo() {
      const extraBlock = [];

      if (typeof member.admin !== 'undefined') {
        Object.keys(member.admin).forEach((item) => {
          if (item === 'use_signature') {
            return;
          }
          extraBlock.push(<div key={item} className="member-infoItem">{member.admin[item]}</div>);
        });
      }

      return (
        <div>
          {extraBlock}
        </div>
      );
    };

    const memberExtendedInfo = function memberExtendedInfo() {
      if (type === 'admin' && subtype === 'duplicates') {
        return null;
      }

      let extraBlock = [];
      let aboutMe = member.about_me;
      const truncate = 70;

      // eslint-disable-next-line react/prop-types
      if (aboutMe.length > 0) {
        // eslint-disable-next-line react/prop-types
        if (aboutMe.length > truncate) {
          // eslint-disable-next-line react/prop-types
          aboutMe = `${aboutMe.substring(0, truncate - 1)}...`;
        }
        extraBlock = [<div key={member._id} className="member-about">{aboutMe}</div>];
      }

      if (type === 'ignored') {
        extraBlock = [
          <div key={member._id} className="member-button">
            <div
              role="presentation"
              onClick={self.onClickUnignore}
              className="btn btn--a btn--small mbs"
              data-post="true"
            >
              <span>{translations['txt: Rādīt meklētājā']}</span>
            </div>
          </div>,
        ];
      }

      if (type === 'blocked') {
        extraBlock = [
          <div key={member._id} className="member-button">
            <div
              role="presentation"
              onClick={self.onClickUnblock}
              className="btn btn--a btn--small mbs"
              data-post="true"
            >
              <span>{translations['txt: Atbloķēt']}</span>
            </div>
          </div>,
        ];
      }

      return (
        <div>
          <div className="member-line" />
          <div className="member-imageCount">{`${translations['txt: Foto']}: ${member.image_count}`}</div>
          {extraBlock}
        </div>
      );
    };

    const getLocation = function getLocation() {
      if (showDistance === true && typeof showDistance !== 'undefined' && member.km_from_me !== null) {
        return (
          <div className="member-location">
            <ImageSvg svg="icon-location" iconClass="icon icon--locationSmall" />
            {` ${member.km_from_me} km`}
          </div>
        );
      }

      if (showDistance === true && typeof showDistance !== 'undefined' && member.km_from_me === null) {
        return (
          <div className="member-location" />
        );
      }

      return (
        <div className="member-location">{member.location}</div>
      );
    };

    return (
      <MemberLink
        key={member._id}
        memberId={member._id}
        linkClass={classNames}
        customLink={customLink}
      >
        <div className="member-image memberMenu-container">
          <MemberImage
            member={member}
            memberId={member._id}
            type={imageType}
            key={member._id}
            top_nr={topNr}
            hideIcons={hideIcons}
          />
          {!hideMenu && (
            <MemberMenu
              memberId={member._id}
              menuItems={menuItems}
              showDialog={this.showDialog}
              fullOpacity={menuFullOpacity}
            />
          )}
        </div>
        <div className="member-info">
          <div className="memberName">
            <MemberName
              key={member._id}
              memberId={member._id}
              hideAnswerScore={hideAnswerScore}
              hideAge={hideAge}
            />
            {(!hideVerificationBadge && member.verified) && (
              <VerificationBadge />
            )}
          </div>
          {!hideLocation && getLocation()}
          {extended && memberExtendedInfo()}
          {type === 'admin' && adminInfo()}
        </div>
        <Dialog ref={(el) => { this.dialog = el; }} />
      </MemberLink>
    );
  }
}

MembersBlockItem.propTypes = {
  member: PropTypes.shape({
    admin: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.instanceOf(Array),
      PropTypes.instanceOf(Object),
    ]),
    about_me: PropTypes.string,
    _id: PropTypes.string,
    image_count: PropTypes.number,
    km_from_me: PropTypes.number,
    location: PropTypes.string,
    status: PropTypes.string,
    verified: PropTypes.bool,
  }),
  memberId: PropTypes.string,
  showDistance: PropTypes.bool,
  customLink: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string,
  topNr: PropTypes.number,
  extended: PropTypes.bool,
  customLinkClass: PropTypes.string,
  imageType: PropTypes.string,
  hideAnswerScore: PropTypes.bool,
  hideVerificationBadge: PropTypes.bool,
  hideAge: PropTypes.bool,
  hideLocation: PropTypes.bool,
  hideMenu: PropTypes.bool,
  hideIcons: PropTypes.bool,
  menuType: PropTypes.string,
};

MembersBlockItem.defaultProps = {
  member: null,
  memberId: null,
  topNr: null,
  customLink: null,
  showDistance: false,
  extended: false,
  type: undefined,
  subtype: '',
  customLinkClass: null,
  imageType: 'o-m',
  hideAnswerScore: false,
  hideVerificationBadge: false,
  hideAge: false,
  hideLocation: false,
  hideMenu: false,
  hideIcons: false,
  menuType: 'user',
};

module.exports = MembersBlockItem;
